import { Dispatch } from 'redux'
import { toast } from 'react-toastify'

import { Pagination } from '../../lib/interfaces/Pagination.interface'
import { Termination } from '../../lib/interfaces/Termination.interface'

import {
  actionTypes,
  createTerminationError,
  deleteTerminationError,
  fetchTerminationError,
  TerminationFetchAction,
  updateTerminationError,
  confirmTerminationError,
  fetchTerminationSuccess,
  TerminationCreateAction,
  TerminationDeleteAction,
  TerminationUpdateAction,
  fetchTerminationsFailure,
  createTerminationSuccess,
  deleteTerminationSuccess,
  fetchTerminationsSuccess,
  TerminationConfirmAction,
  updateTerminationSuccess,
  confirmTerminationSuccess,
  TerminationFetchListAction,
} from './actions'

import {
  getTermination,
  getTerminations,
  createTermination,
  deleteTermination,
  updateTermination,
  confirmTermination,
} from '../../lib/api/terminations'

const get = require('lodash/get')

const { createLogic } = require('redux-logic')

type OnDoneType = () => void

const onFetchTerminationsListLogic = createLogic({
  type: actionTypes.TERMINATIONS_FETCH_LIST,
  process({ action }: { action: TerminationFetchListAction }, dispatch: Dispatch, done: OnDoneType) {
    getTerminations(action.payload.page)
      .then((listResponse: Pagination<Termination>) => dispatch(fetchTerminationsSuccess(listResponse)))
      .catch(err => dispatch(fetchTerminationsFailure(err)))
      .then(done)
  }
})

const onFetchTerminationLogic = createLogic({
  type: actionTypes.TERMINATIONS_FETCH,
  process({ action }: { action: TerminationFetchAction }, dispatch: Dispatch, done: OnDoneType) {
    const { next, terminationId } = action.payload

    getTermination(terminationId)
      .then((termination: Termination) => {
        dispatch(fetchTerminationSuccess(termination))

        if (next) { next(null, termination) }
      })
      .catch(err => {
        dispatch(fetchTerminationError(err))

        if (next) { next(err) }
      })
      .then(done)
  }
})

const onCreateTerminationLogic = createLogic({
  type: actionTypes.TERMINATIONS_CREATE,
  process({ action }: { action: TerminationCreateAction }, dispatch: Dispatch, done: OnDoneType) {
    const { next } = action.payload

    const payload: any = { ...action.payload.termination }
    payload.employeeId = payload.employee.id
    delete payload.employee

    createTermination(payload)
      .then((termination: Termination) => {
        dispatch(createTerminationSuccess(termination))
        toast.success('Termination successfully created.')

        if (next) { next(null, termination) }
      })
      .catch(err => {
        const errorMessage = get(err, 'response.data.message', 'Error creating termination. Please try again')
        dispatch(createTerminationError(errorMessage))
        toast.error(errorMessage)

        if (next) { next(err) }
      })
      .then(done)
  }
})

const onUpdateTerminationLogic = createLogic({
  type: actionTypes.TERMINATIONS_UPDATE,
  process({ action }: { action: TerminationUpdateAction }, dispatch: Dispatch, done: OnDoneType) {
    const { next } = action.payload

    updateTermination(action.payload.terminationId, action.payload.termination)
      .then((termination: Termination) => {
        dispatch(updateTerminationSuccess(termination))
        toast.success('Termination successfully updated.')

        if (next) { next(null, termination) }
      })
      .catch(err => {
        const errorMessage = get(err, 'response.data.message', 'Error updating termination. Please try again')
        dispatch(createTerminationError(errorMessage))
        toast.error(errorMessage)

        if (next) { next(err) }
      })
      .then(done)
  }
})

const onConfirmTerminationLogic = createLogic({
  type: actionTypes.TERMINATIONS_CONFIRM,
  process({ action }: { action: TerminationConfirmAction }, dispatch: Dispatch, done: OnDoneType) {
    const { next } = action.payload

    confirmTermination(action.payload.terminationId)
      .then((termination: Termination) => {
        dispatch(confirmTerminationSuccess(termination))
        toast.success('Termination successfully confirmed.')

        if (next) { next(null, termination) }
      })
      .catch(err => {
        const errorMessage = get(err, 'response.data.message', 'Error confirming termination. Please try again')
        dispatch(confirmTerminationError(errorMessage))
        toast.error(errorMessage)

        if (next) { next(err) }
      })
      .then(done)
  }
})

const onDeleteTerminationLogic = createLogic({
  type: actionTypes.TERMINATIONS_DELETE,
  process({ action }: { action: TerminationDeleteAction }, dispatch: Dispatch, done: OnDoneType) {
    const { next, terminationId } = action.payload

    deleteTermination(terminationId)
      .then(() => {
        dispatch(deleteTerminationSuccess(terminationId))
        toast.success('Termination successfully deleted.')

        if (next) { next() }
      })
      .catch(err => {
        const errorMessage = get(err, 'response.data.message', 'Error deleting termination. Please try again')
        dispatch(deleteTerminationError(errorMessage))
        toast.error(errorMessage)

        if (next) { next(err) }
      })
      .then(done)
  }
})

export const fetchTerminationsLogic = [
  onFetchTerminationsListLogic,
  onFetchTerminationLogic,
  onCreateTerminationLogic,
  onUpdateTerminationLogic,
  onConfirmTerminationLogic,
  onDeleteTerminationLogic
]



// WEBPACK FOOTER //
// ./src/store/terminations/logic.ts